import { useI18n } from '@i18n/I18nProvider'
import { LOCALES, type Locale } from '@i18n/locale'

const NAMES: Record<Locale, string> = { es: 'Español', en: 'English', fr: 'Français' }

// Selector de idioma siempre visible (sobre la cabecera oliva): cada idioma se nombra en su
// propia lengua.
export const LanguageSwitcher = () => {
	const { locale, setLocale, t } = useI18n()
	return (
		<fieldset className="flex gap-1 rounded-full bg-black/15 p-1" aria-label={t('common.language')}>
			{LOCALES.map((code) => (
				<button
					key={code}
					type="button"
					lang={code}
					aria-pressed={locale === code}
					aria-label={NAMES[code]}
					onClick={() => setLocale(code)}
					className={`min-h-10 min-w-10 rounded-full px-2 text-sm font-bold uppercase ${locale === code ? 'bg-white text-olive-900' : 'text-white'}`}
				>
					{code}
				</button>
			))}
		</fieldset>
	)
}
